import * as psndoc from "@/api/base/psndoc";
import Vue from "vue";

/**
 * 定义数据
 */
const state = {
  equipment: {xxx: "xx"},
  psndoc: {xxx: "xx"}
};

/**
 * 定义mutations
 */
const mutations = {
  updatePsndoc: (state, pk) => {
    if (pk) {
      if (!state.psndoc[pk]) {
        psndoc.get(pk).then(resp => {
          Vue.set(state.psndoc, pk, resp.data);
        }).catch(error => {
        });
      }
    }
  }
};

/**
 * 定义getters
 */
const getters = {};

/**
 * 定义actions
 */
const actions = {};

export default {
  name: "cache",
  data: {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
  }
}



// WEBPACK FOOTER //
// ./src/store/cache/cache.js